import React from 'react';
import { Crown, ChevronRight } from 'lucide-react';
import SubscriptionCard from '@/components/SubscriptionCard';

const DashboardPremium = ({
  hasSubscription,
  showPremiumBanner,
  setShowPremiumBanner
}) => {
  return (
    <>
      {!hasSubscription ? (
        <div className="mb-6">
          {!showPremiumBanner ? (
            <button
              onClick={() => setShowPremiumBanner(true)}
              className="w-full group flex items-center justify-between gap-4 bg-gradient-to-r from-red-50 via-white to-red-50 border-2 border-dashed border-[#E6202E]/40 hover:border-[#E6202E] rounded-2xl px-5 py-4 transition-all hover:shadow-md"
              data-testid="show-premium-banner-link"
            >
              <div className="flex items-center gap-3 text-left">
                <div className="w-10 h-10 rounded-full bg-[#E6202E]/10 flex items-center justify-center shrink-0 group-hover:bg-[#E6202E]/20 transition-colors">
                  <Crown className="w-5 h-5 text-[#E6202E]" />
                </div>
                <div>
                  <p className="font-bold text-gray-900">¿Quieres acceder a más clientes?</p>
                  <p className="text-sm text-gray-500">Descubre los beneficios de U-CAN Premium</p>
                </div>
              </div>

              <span className="hidden sm:inline-flex items-center gap-1 px-4 py-2 bg-[#E6202E] text-white text-sm font-semibold rounded-full group-hover:bg-[#D31522] transition-colors">
                Ver más
                <ChevronRight className="w-4 h-4" />
              </span>

              <ChevronRight className="sm:hidden w-5 h-5 text-[#E6202E]" />
            </button>
          ) : (
            <SubscriptionCard userType="provider" hasSubscription={hasSubscription} />
          )}
        </div>
      ) : (
        <div className="mb-6">
          <SubscriptionCard userType="provider" hasSubscription={hasSubscription} />
        </div>
      )}
    </>
  );
};

export default DashboardPremium;
